import { CustomYup } from 'validations/CustomYup'

const uploadTaskFilesUserSchema = CustomYup.object().shape({
  files: CustomYup.mixed().required('Plik jest wymagany'),
})

export default uploadTaskFilesUserSchema
